import { throwError } from 'rxjs';

export class HttpError {
  public static handleError(error) {
    let errorMessage = {};
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = {message: error.error.message};
    } else {
      // Get server-side error
      errorMessage =  {status: error.status, message: error.error.message};
    }
    console.log('error', error);
    return throwError(errorMessage);
  }
}
